// extracted by mini-css-extract-plugin
var _1 = "Pagination_active__gB5Ok";
var _2 = "Pagination_container__eBq0v";
var _3 = "Pagination_disabled__rGDOo";
var _4 = "Pagination_next__M6+Cp";
var _5 = "Pagination_page__tCPyC";
var _6 = "Pagination_paginationBreak__l29f7";
var _7 = "Pagination_previous__nxI1N";
export { _1 as "active", _2 as "container", _3 as "disabled", _4 as "next", _5 as "page", _6 as "paginationBreak", _7 as "previous" }
